import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { NavService } from '../../../../services/nav.service';
import { HeaderComponent } from '../../header/header.component';
import { SideNavComponent } from '../../side-nav/side-nav.component';
import { TripActivityComponent } from '../../activity/trip-activity/trip-activity.component';
import { ExpenseActivityComponent } from '../../activity/expense-activity/expense-activity.component';
import { NotificationsComponent } from '../../activity/notifications/notifications.component';
import { HelpAndSupportComponent } from '../../support/help-and-support/help-and-support.component';
import { RequestACallComponent } from '../../support/request-a-call/request-a-call.component';
import { ContactSupportComponent } from '../../support/contact-support/contact-support.component';
import { TableFilterComponent } from '../../header/table-header/table-filter/table-filter.component';
import { GradeDetailsComponent } from '../../../modules/settings/basic-information/grade-details/grade-details.component';
import { CancelJourneyComponent } from '../../../modules/trip/trip-details/cancel-journey/cancel-journey.component';
import { ChangePasswordComponent } from '../../support/change-password/change-password.component';
import { NewTravelDocComponent } from '../../../modules/settings/travel-documents/new-travel-doc/new-travel-doc.component';

@Component({
  selector: 'app-shell',
  exportAs: 'appShell',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    HeaderComponent,
    SideNavComponent,
    TripActivityComponent,
    ExpenseActivityComponent,
    NotificationsComponent,
    HelpAndSupportComponent,
    RequestACallComponent,
    ContactSupportComponent,
    TableFilterComponent,
    GradeDetailsComponent,
    CancelJourneyComponent,
    ChangePasswordComponent,
    NewTravelDocComponent,
  ],
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.scss',
})
export class AppShellComponent {
  @Input() showChrome: boolean = true;
  @Input() forceNavOpenOnInit: boolean = false;

  isNavOpen: boolean = true;
  isMobileNav: boolean = false;
  isMobileNavOpen: boolean = false;
  nav: any = null;
  @ViewChild('drawer') drawer!: MatDrawer;

  constructor(public navService: NavService) {
    if (this.forceNavOpenOnInit) {
      this.navService.updateNav(true);
    }
    this.navService.isNavOpen().subscribe((value: boolean) => {
      this.isNavOpen = value;
    });
    this.navService.getIsMobileNavOpen().subscribe((value: boolean) => {
      this.isMobileNavOpen = value;
    });
    this.navService.getIsMobileNav().subscribe((value: boolean) => {
      this.isMobileNav = value;
    });
    this.navService.getSideNav().subscribe((nav: any) => {
      this.nav = nav;
      if (nav?.toogle) {
        this.drawer?.toggle();
      }
    });
  }
}
